<template>
  <div>
    <search-input
      alias="Cliente"
      v-model="form.client_id.value"
      :displayedValue="form.name.value"
      :form="form"
      :name="'client_id'"
      @search="searchPerson($event)"
      :searchResult="searchPersonResults.results"
      :isLoading="searchPersonResults.isLoading"
      @selected="setPerson($event)"
    >
      <search-input-option
        v-for="(row, index) in searchPersonResults.results.data"
        :key="index"
        :index="index"
        @click="setPerson(row)"
      >
        <div>
          {{ row.name }} -
          <small class="text-muted"> #{{ row.person_code }}</small>
          <br />
          <small v-if="row.person_type == 'f'" class="text-muted">Cpf:{{ row.cpf }}</small>
          <small v-if="row.person_type == 'j'" class="text-muted">Cnpj:{{ row.cnpj }}</small>
          <template v-if="row.phone_wa">
            <br/>
            <small class="text-muted">WhatsApp:{{ row.phone_wa | phone }}</small>
          </template>
          <br />
        </div>
      </search-input-option>
    </search-input>
  </div>
</template>

<script>
import Form from "./../mixins/Form.js";

export default {
  props: {
    value: {},
    name: {},
  },

  data: function () {
    return {
      form: new Form({
        client_id: {
          alias: "Cliente",
          validate: { required: true },
          value: null,
        },

        name: {},
      }),

      searchPersonResults: {
        results: {},
        isLoading: false,
      },
    };
  },

  created() {
    this.form.client_id.value = this.value;
    this.form.name.value = this.name;
  },

  computed: {
    client_id() {
      return this.form.client_id.value;
    },

    persons() {
      return this.$store.state.person.persons;
    },
  },

  watch: {
    client_id(newValue) {
      this.$emit("input", newValue);
    },

    name: function (newValue, oldValue) {
      this.form.name.value = this.name;
    },

    value: function (newValue, oldValue) {
      this.form.client_id.value = newValue;
    },
  },

  methods: {
    searchPerson(search) {
      this.searchPersonResults.isLoading = true;

      this.$store
        .dispatch("person/getPersons", {
          page: search.page,
          name: search.text,
          type: "c",
          status: 1
        })
        .then((response) => {
          this.searchPersonResults.results = this.persons;

          this.searchPersonResults.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        });
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.client_id.value = person.id;

      this.form.name.value = person.name;

      this.$emit("personSelected", person);
    },
  },
};
</script>

<style>
</style>
